import React, { useContext } from 'react';
import { Box, Button, Card, useTheme } from '@mui/material';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import IconAndText from './IconAndText';
import { UIContext } from '../context/UIContext';

const CardRadioWithTextAndImage = ({
  onClickAction,
  isSelected,
  optionHeaderContent,
  optionBodyContent,
}: {
  onClickAction: () => void;
  isSelected: boolean;
  optionHeaderContent: JSX.Element;
  optionBodyContent?: JSX.Element;
}) => {
  const theme = useTheme();
  const { colorMode } = useContext(UIContext);

  return (
    <Card
      variant="outlined"
      onClick={onClickAction}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1rem',
        cursor: 'pointer',
        ...(isSelected
          ? {
              border: `1px solid ${theme?.palette?.primary?.main}`,
            }
          : {
              border: `1px solid ${
                colorMode === 'light' ? theme.palette.grey['12p'] : theme.palette.grey['23p']
              }`,
            }),
        ':hover': {
          ...(!isSelected && {
            border: `1px solid ${theme?.palette?.grey?.['50p']}`,
            '.radio-selection': {
              ...(!isSelected && {
                backgroundColor: `${theme?.palette?.grey?.['4p']}`,
              }),
            },
          }),
        },
      }}
    >
      <Box
        className="radio-selection"
        sx={{
          padding: '1rem',
          backgroundColor: isSelected ? 'secondary.main' : 'background.paper',
          ...(optionBodyContent && {
            borderBottom: isSelected
              ? `1px solid ${theme?.palette?.primary?.main}`
              : `1px solid ${
                  colorMode === 'light' ? theme.palette.grey['12p'] : theme.palette.grey['23p']
                }`,
          }),
        }}
      >
        <IconAndText
          icon={
            isSelected ? (
              <Box
                sx={{
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Button disableRipple sx={{ ':hover': { backgroundColor: 'unset' } }}>
                  <RadioButtonCheckedIcon sx={{ color: 'primary.main' }} />
                </Button>
              </Box>
            ) : (
              <Box
                sx={{
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Button disableRipple sx={{ ':hover': { backgroundColor: 'unset' } }}>
                  <RadioButtonUncheckedIcon sx={{ color: 'text.secondary' }} />
                </Button>
              </Box>
            )
          }
          textComponent={
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {optionHeaderContent}
            </Box>
          }
        />
      </Box>

      {optionBodyContent && (
        <Box
          sx={{
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '1rem',
          }}
        >
          {optionBodyContent}
        </Box>
      )}
    </Card>
  );
};

export default CardRadioWithTextAndImage;
